import { ShoppingCartOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAsync } from 'react-use';

import { toggleCart, updateCartCount } from '../../actions/CartAction';
import { fetchAPI } from '../../utils/api';

export default () => {
  const dispatch = useDispatch();
  const count = useSelector((state: AppState) => state.cart.count);
  useAsync<void>(async () => {
    try {
      const { count } = await fetchAPI('cart/count');
      dispatch(updateCartCount(count));
    } catch (e) {}
  });

  return (
    <Badge count={count}>
      <Button
        onClick={() => dispatch(toggleCart())}
        icon={<ShoppingCartOutlined />}
        shape="circle"
      />
    </Badge>
  );
};
